import { format } from '@seek/currency';
import { constructSalaryDisplayText } from '@seek/unified-display-salary';

import { LANGUAGE } from 'src/app/constants/configObjectProperties';
import { LANGUAGE_LOCALE_DEFAULT } from 'src/app/constants/language';
import { getConfig } from 'src/app/utils/config';
import type { PayType } from 'src/types/salaryTypes';

import { PayTypeToSalaryTypeMap } from '../mappers';

export const formatSalaryWithCurrency = (
  amount: number | null = 0,
  currency: string,
): string => {
  if (amount === null || isNaN(parseFloat(amount?.toString()))) {
    return '';
  }

  return format(amount, {
    currency,
    locale: getConfig(LANGUAGE, LANGUAGE_LOCALE_DEFAULT),
    display: 'noSymbol',
    dropFraction: true,
  });
};

export const constructDefaultSalaryDisplayText = ({
  min,
  max,
  currency,
  payType,
}: {
  min?: number | null;
  max?: number | null;
  currency: any;
  payType: PayType;
}): string => {
  const result = constructSalaryDisplayText({
    // TO-DO: Update @seek/unified-display-salary to contain null type
    // @ts-ignore
    min,
    // @ts-ignore
    max,
    currency,
    locale: getConfig(LANGUAGE, LANGUAGE_LOCALE_DEFAULT),
    frequency: PayTypeToSalaryTypeMap[payType],
  });
  return result;
};
